<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
        <v-alert
            :value="alerteditar"
            color="green"
            dark
            dismissible
            border="top"
            transition="scale-transition"
        >
          Se edito su perfil con éxito.
        </v-alert>
        <v-row justify="center">
          <v-col cols="12" lg="8" md="8" sm="12">

            <v-card color="#393E46">
              <v-card-title>
                Direccion
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-autocomplete
                        v-model="usuario.distrito.ciudad.provincia.pais"
                        :items="paises"
                        return-object
                        label="Pais de Residencia"
                        placeholder="Pais de Residencia"
                        prepend-icon="fas fa-flag"
                        item-text="pais"
                        @change="dameProvincias"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"

                        >
                          <v-avatar left>
                            <v-img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)"></v-img>
                          </v-avatar>
                          {{ data.item.pais }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-avatar>
                            <img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)">
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.pais"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>

                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-autocomplete @change="dameCiudades" label="Provincia" placeholder="Provincia" item-text="provincia" return-object v-model="usuario.distrito.ciudad.provincia" :items="provincias">

                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-autocomplete @change="dameDistritos" placeholder="Ciudad" label="Ciudad" item-text="ciudad"  return-object v-model="usuario.distrito.ciudad" :items="ciudades">

                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-autocomplete placeholder="Distrito" v-model="usuario.distrito" return-object item-text="distrito" label="Distrito" :items="distritos">

                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-text-field
                        prepend-icon="fas fa-map-pin" v-model="usuario.direccion" placeholder="Direccion" label="Direccion"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col>
                <v-btn color="primary" @click="cambiaUsuario">
                  Guardar
                </v-btn></v-col>
                  <v-col>
                    <v-btn color="red">
                      <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'password'}">Cambiar Password</router-link>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn color="blue">
                      <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'fotoperfil'}">Foto</router-link>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn color="green">
                      <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'perfil'}">Datos</router-link>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>

        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import axios from 'axios';
import moment from "moment";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'direccion',
  title: 'Editar Direccion | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
  data: () => ({
    paises: {},
    overlay:false,
    date: new Date().toISOString().substr(0, 10),
    provincias:[],
    alerteditar: false,
    ciudades:[],
    distritos:[],
    tiposdocumento: [],
    token:'',
    getips:'',
    menu1:false,
  }),
  mounted() {
    if(this.usuario.id>0){
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.getPaises()
    if(this.usuario.distrito.ciudad.provincia.pais.id>0){
      this.dameProvincias()
      if(this.usuario.distrito.ciudad.provincia.id>0){
        this.dameCiudades()
        if(this.usuario.distrito.ciudad.id>0){
          this.dameDistritos()
        }
      }
    }}else{
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.getPaises()
              if(this.usuario.distrito.ciudad.provincia.pais.id>0){
                this.dameProvincias()
                if(this.usuario.distrito.ciudad.provincia.id>0){
                  this.dameCiudades()
                  if(this.usuario.distrito.ciudad.id>0){
                    this.dameDistritos()
                  }
                }
              }
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }
  },
  watch:{
    '$store.state.usuario': function (){
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.getPaises()
      if(this.usuario.distrito.ciudad.provincia.pais.id>0){
        this.dameProvincias()
        if(this.usuario.distrito.ciudad.provincia.id>0){
          this.dameCiudades()
          if(this.usuario.distrito.ciudad.id>0){
            this.dameDistritos()
          }
        }
      }
    },
  },
  methods:{
    getPaises(){
      axios.get("paises/activos",{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.paises = response.data
          })
    },

    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    dameProvincias(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'provincias/pais/' + this.usuario.distrito.ciudad.provincia.pais.id ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.provincias = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameCiudades(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'ciudades/provincia/' + this.usuario.distrito.ciudad.provincia.id ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.ciudades = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameDistritos(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'distritos/ciudad/' + this.usuario.distrito.ciudad.id ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.distritos = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    cambiaUsuario(){
      var bodyFormData = new FormData();
      this.usuario.createdAt = this.formatDateee(new Date(this.usuario.createdAt))

      bodyFormData.append('data',JSON.stringify(this.usuario));
      axios.post("personas/save",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {

            console.log(response.data)
            store.dispatch("fetchUsuario", this.usuario);
            this.overlay = false;
            this.dialog=false;
            this.alerteditar = true;
         //  this.abreviado =this.usuario.nombre.charAt(0) + this.usuario.apellidoPaterno.charAt(0)
            this.desconectado = false;
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false;
            console.log(error);
          });
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>
